import { SvgIcon, SvgIconProps } from '@mui/material';

import './ccf-dual-assignment-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfDualAssignmentIconProps extends SvgIconProps {}

/**
 * This function is used to display svg dual assignment icon
 * @param props -CcfDualAssignmentProps
 * @returns dual assignment icons
 * @example <CcfDualAssignment/>
 */
export function CcfDualAssignmentIcon(props: CcfDualAssignmentIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Group_120843" data-name="Group 120843" transform="translate(-227 -66)">
        <rect id="Rectangle_81093" data-name="Rectangle 81093" width="29" height="20" rx="4" transform="translate(227 66)" fill="#f2f2f2" />
        <g id="Group_120840" data-name="Group 120840" transform="translate(234.52 70.548)">
          <g id="Group_120782" data-name="Group 120782" transform="translate(0)">
            <g id="btn_inbound" transform="translate(0.48 -3.548)">
              <path id="Path_25429" data-name="Path 25429" d="M3847.5-3110.5v4.182h12.96v-4.182" transform="translate(-3847.501 3121.771)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              <path id="Polygon_90" data-name="Polygon 90" d="M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z" transform="translate(11 14) rotate(180)" fill="#526b7a" />
              <path id="Polygon_91" data-name="Polygon 91" d="M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z" transform="translate(2)" fill="#526b7a" />
              <path id="Path_25436" data-name="Path 25436" d="M4730.5-2433.75v-7.753" transform="translate(-4724 2445)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDualAssignmentIcon;
